export const POST_ADMIN_LOGIN = "ADMIN_LOGIN";
export const POST_ADMIN_LOGOUT = "POST_ADMIN_LOGOUT";
export const GET_ADMIN_PROFILE = "GET_ADMIN_PROFILE";
export const GET_ADMIN_REFRESH_AUTH = "GET_ADMIN_REFRESH_AUTH";